import React, { useState, useEffect } from 'react';

import './Skills.scss';
import { motion, AnimatePresence } from 'framer-motion';
import {
  fadeinTop,
  pageTransitions,
  fadeinslow,
  fadeinfast,
} from '../../animations';

import { useInView, InView } from 'react-intersection-observer';

import windows10 from '../../Assets/Icons/windows10.png';
import linux from '../../Assets/Icons/linux.png';
import javascript from '../../Assets/Icons/javascript.png';
import python from '../../Assets/Icons/python.png';
import cpp from '../../Assets/Icons/cpp.png';
import html from '../../Assets/Icons/html.png';
import sass from '../../Assets/Icons/sass.png';
import typescript from '../../Assets/Icons/typescript.png';
import java from '../../Assets/Icons/java.png';
import reactPic from '../../Assets/Icons/react.png';
import bootstrap from '../../Assets/Icons/bootstrap.png';
import mongodb from '../../Assets/Icons/mongodb.png';
import nodejs from '../../Assets/Icons/nodejs.png';
import firebase from '../../Assets/Icons/firebase.png';
import mysql from '../../Assets/Icons/mysql.png';
import socketio from '../../Assets/Icons/socketio.png';
import threejs from '../../Assets/Icons/threejs.png';

const Skills = (props) => {
  const [top, setTop] = useState(0);
  const handleScroll = (e) => {
    setTop(e.target.scrollTop);
  };
  useEffect(() => {
    if (top > 170) props.setDarkenNavbar(true);
    else props.setDarkenNavbar(false);
  }, [top]);
  return (
    <motion.div
      className="Skills_Page"
      variants={pageTransitions}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div
        className="Skills_Page__page-content Scrollable"
        onScroll={handleScroll}
      >
        <motion.div
          className="Skills_Page__page-content__Title"
          variants={fadeinslow}
          initial="hidden"
          animate="visible"
        >
          <div className="Skills_Page__page-content__Title-heading">SKILLS</div>
          <div className="Skills_Page__page-content__Title-details">
            Web Developer | Student | Competitive Programmer
          </div>
        </motion.div>

        <motion.div className="Skills_Page__page-content__Info">
          {/* <section className="Skills_Page__page-content__Info__Technologies margin-bottom-small">
            <div className="Skills_Page__page-content__Info__Technologies__heading">
              Technologies
            </div>
            <div className="Skills_Page__page-content__Info__Technologies__content">
              <div className="ReactJs tech">
                <div className="tech-name">REACT JS</div>
                <div className="Pie-progress">
                  <div>{90}</div>
                  <svg>
                    <circle class="bg" cx="40" cy="40" r="35" />
                    <circle
                      class="meter-1"
                      cx="40"
                      cy="40"
                      r="35"
                      strokeDasharray="219.9"
                      strokeDashoffset={`${219.9 * (1 - 90 / 100)}`}
                    />
                  </svg>
                </div>
              </div>
              <div className="NodeJs tech">
                <div className="tech-name">NODE JS</div>
                <div className="Pie-progress">
                  <div>{70}</div>
                  <svg>
                    <circle class="bg" cx="40" cy="40" r="35" />
                    <circle
                      class="meter-1"
                      cx="40"
                      cy="40"
                      r="35"
                      strokeDasharray="219.9"
                      strokeDashoffset={`${219.9 * (1 - 70 / 100)}`}
                    />
                  </svg>
                </div>
              </div>
              <div className="ReactJs tech">
                <div className="tech-name">REACTJS</div>
                <div className="Pie-progress">
                  <div>{90}</div>
                  <svg>
                    <circle class="bg" cx="40" cy="40" r="35" />
                    <circle
                      class="meter-1"
                      cx="40"
                      cy="40"
                      r="35"
                      strokeDasharray="219.9"
                      strokeDashoffset={`${219.9 * (1 - 10 / 100)}`}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </section> */}

          {/* <InView threshold={0}>
            {({ inView, ref, entry }) => ( */}
          <motion.section
            // ref={ref}
            className="Skills_Page__page-content__Info__Platforms "
            variants={fadeinfast}
            // initial="hidden"
            // animate={inView ? 'visible' : ''}
          >
            <div className="Skills_Page__page-content__Info__Platforms__heading">
              Platforms
            </div>
            <div className="Skills_Page__page-content__Info__Platforms__content margin-top-small show-name">
              <div>
                <img src={windows10} />
                <div>Windows</div>
              </div>
              <div>
                <img src={linux} />
                <div>Linux</div>
              </div>
            </div>
          </motion.section>
          {/* )}
          </InView> */}
          {/* <InView threshold={0}>
            {({ inView, ref, entry }) => ( */}
          <motion.section
            // ref={ref}
            className="Skills_Page__page-content__Info__Languages margin-bottom-small"
            variants={fadeinfast}
            // initial="hidden"
            // animate={inView ? 'visible' : ''}
          >
            <div className="Skills_Page__page-content__Info__Languages__heading">
              Languages
            </div>
            <div className="Skills_Page__page-content__Info__Languages__content margin-top-small show-name">
              <div>
                <img src={javascript} />
                <div>Javascript</div>
              </div>
              <div>
                <img src={python} />
                <div>Python</div>
              </div>
              <div>
                <img src={cpp} />
                <div>C++</div>
              </div>
              <div>
                <img src={html} />
                <div>Html</div>
              </div>
              <div>
                <img src={sass} />
                <div>Sass</div>
              </div>
              <div>
                <img src={typescript} />
                <div>Typescript</div>
              </div>
              <div>
                <img src={java} />
                <div>Java</div>
              </div>
            </div>
          </motion.section>
          {/* )}
          </InView> */}
          {/* <InView threshold={0}>
            {({ inView, ref, entry }) => ( */}
          <motion.section
            // ref={ref}
            className="Skills_Page__page-content__Info__Tech "
            variants={fadeinfast}
            // initial="hidden"
            // animate={inView ? 'visible' : ''}
          >
            <div className="Skills_Page__page-content__Info__Tech__heading">
              Technologies
            </div>
            <div className="Skills_Page__page-content__Info__Tech__content margin-top-small show-name">
              <div>
                <img src={reactPic} />
                <div>ReactJS</div>
              </div>
              <div>
                <img src={mongodb} />
                <div>MongoDb</div>
              </div>
              <div>
                <img src={nodejs} />
                <div>NodeJs</div>
              </div>
              <div>
                <img src={firebase} />
                <div>Firebase</div>
              </div>
              <div>
                <img src={socketio} />
                <div>Socket Io</div>
              </div>
              <div>
                <img
                  src={mysql}
                  style={{ backgroundColor: 'white', borderRadius: '50%' }}
                />
                <div>Mysql</div>
              </div>
              <div>
                <img src={threejs} style={{ borderRadius: '50%' }} />
                <div>Three Js</div>
              </div>
              <div>
                <img src={bootstrap} />
                <div>Bootstrap</div>
              </div>
            </div>
          </motion.section>
          {/* )}
          </InView> */}
        </motion.div>
      </div>
    </motion.div>
  );
};
export default Skills;
